module.exports = __webpack_public_path__ + "img/aikasa.c33529a9.png";